import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    baseData: [],
    categories: [],
    subCategories: [],
    microCategories: [],
    currentSelected: {
      category: {},
      subCategory: {},
    },
    socketMessages: [],
  },
  actions,
  mutations,
  getters,
};
